export const PASSWORD_ERROR_MESSAGE =
  'The password must contain 8 letters, with at least a symbol, upper and lower case letters and a number';
export const PASSWORD_CONFIRM_ERROR_MESSAGE = 'The passwords must match';
